import type { ReactNode } from 'react'
import { SlidersHorizontal } from 'lucide-react'
import { Button } from '@/shared/components/ui/button'
import {
  Sheet,
  SheetClose,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from '@/shared/components/ui/sheet'

export function MobileFiltersSheet({
  triggerLabel,
  sheetCloseLabel,
  title,
  description,
  applyLabel,
  clearLabel,
  onClear,
  children,
  triggerClassName,
}: {
  triggerLabel: string
  sheetCloseLabel: string
  title: string
  description?: string
  applyLabel: string
  clearLabel: string
  onClear: () => void
  children: ReactNode
  triggerClassName?: string
}) {
  return (
    <Sheet>
      <SheetTrigger asChild>
        <Button type="button" variant="outline" className={triggerClassName ?? 'w-full lg:hidden'}>
          <SlidersHorizontal className="size-4" aria-hidden />
          {triggerLabel}
        </Button>
      </SheetTrigger>
      <SheetContent
        side="bottom"
        sheetCloseLabel={sheetCloseLabel}
        className="flex max-h-[90dvh] flex-col gap-0 overflow-hidden p-0"
      >
        <SheetHeader className="shrink-0 border-b border-border px-6 pb-4 pt-2">
          <SheetTitle>{title}</SheetTitle>
          {description ? <SheetDescription>{description}</SheetDescription> : null}
        </SheetHeader>
        <div className="min-h-0 flex-1 overflow-y-auto px-6 py-4">{children}</div>
        <div className="flex shrink-0 gap-2 border-t border-border bg-background px-6 py-4 pb-[max(1rem,env(safe-area-inset-bottom))]">
          <Button type="button" variant="outline" className="flex-1" onClick={onClear}>
            {clearLabel}
          </Button>
          <SheetClose asChild>
            <Button type="button" className="flex-1">
              {applyLabel}
            </Button>
          </SheetClose>
        </div>
      </SheetContent>
    </Sheet>
  )
}
